import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAuthorized } from 'src/util/Permissions';
import { getUserEmailFromToken } from 'src/util/helpers';
import PermissionsError from 'src/components/common/PermissionsError/PermissionsError';
import { PAGE_INFO } from 'src/util/constants';
import { FmtpPage } from 'src/components/common/NavigationMenu/types';
import { PageNames } from 'src/util/types';
import { Permissions } from '@lanterds/types';

export default function AdminLayout() {
    const userEmail = getUserEmailFromToken();
    const { pathname } = useLocation();

    const currentPath = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

    // Handle users accessing "/admin"
    if (currentPath === PAGE_INFO.admin.href) {
        const usersPage = PAGE_INFO.admin.subPages?.find((page: FmtpPage) => page.name === PageNames.Users);
        const customersPage = PAGE_INFO.admin.subPages?.find((page: FmtpPage) => page.name === PageNames.Customers);
        const reportsPage = PAGE_INFO.admin.subPages?.find((page: FmtpPage) => page.name === PageNames.ReportManagement);

        if (usersPage && isAuthorized(userEmail, Permissions.userManagement)) {
            return <Navigate to={usersPage.href} replace />;
        } else if (customersPage && isAuthorized(userEmail, Permissions.customerManagement)) {
            return <Navigate to={customersPage.href} replace />;
        } else if (reportsPage && isAuthorized(userEmail, Permissions.reportManagement)) {
            return <Navigate to={reportsPage.href} replace />;
        } else {
            return <PermissionsError />;
        }
    }

    // Handle sub pages
    const subPage = PAGE_INFO.admin.subPages?.find((page) => currentPath.startsWith(page.href));

    if (subPage) {
        const isUserAuthorized = subPage.permissions?.some((permission) => isAuthorized(userEmail, permission));
        return isUserAuthorized ? <Outlet /> : <PermissionsError />;
    }

    return <PermissionsError />;
}
